module.exports = __webpack_public_path__ + "static/img/kuang2.4852fe9.png";